import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { Asterisk } from '../';
import { TooltipHeader } from './TooltipHeader';

var Flags = function Flags(_ref) {
  var classes = _ref.classes,
      content = _ref.content;

  var codes = R.pipe(R.pluck('code'), R.filter(R.identity))(content);
  var hasCodes = !R.isEmpty(codes);
  var hasUncoded = R.length(codes) !== R.length(content);
  var joinedCodes = R.pipe(R.join(','), function (codes) {
    return hasUncoded ? codes + ',' : codes;
  })(codes);
  return React.createElement(
    TooltipHeader,
    { classes: classes, content: content },
    React.createElement(
      'sup',
      { className: classes.svgWrapper },
      hasCodes && joinedCodes,
      hasUncoded && React.createElement(Asterisk, { className: classes.svg })
    )
  );
};

Flags.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: PropTypes.object,
  content: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.string,
    label: PropTypes.string,
    sub: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string
    }))
  }))
} : {};

export default Flags;